<template>
  <el-dialog
    class="theme-dialog dialog-center dialog-body-0"
    :title="title"
    width="455px"
    top="0"
    :center="true"
    :close-on-click-modal="false"
    :visible.sync="visibility"
  >
    <div class="px-6 pt-5 pb-4">
      <div class="w-full rounded-small bg-theme-gray">
        <textarea
          style="height: 288px"
          class="w-full px-3 py-1 box-border outline-none resize-none bg-transparent"
          :maxlength="maxlength"
          :placeholder="placeholder"
          v-model="textValue"
        ></textarea>
        <div class="w-full px-3 box-border text-right text-theme-text-gray text-small leading-22">
          {{textValue.length}}/{{maxlength}}
        </div>
      </div>
      <p class="mt-1 flex items-center text-yellow-theme" v-if="submitType === 'add'">
        <i class="el-icon-warning-outline text-medium"></i>
        <span class="ml-1 text-small leading-22">
          每个维度名称建议控制 10 个字以内，最多支持 30 字
        </span>
      </p>
    </div>
    <template #footer>
      <footer class="text-right">
        <el-button class="normal-button" size="small" @click="cancelHandle">取消</el-button>
        <el-button
          class="normal-button"
          size="small"
          type="primary"
          :loading="confirmLoading"
          @click="confirmHandle"
        >确定</el-button>
      </footer>
    </template>
  </el-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog'
import { addDimension, editDimension } from '@/api/wenjuan/dimensionScore';

export default {
  name: 'AddDimensionDialog',
  mixins: [dialogMixins],
  props: {
    onConfirm: {
      type: [Function, null],
      default: null
    },
    title: {
      type: String,
      default: '添加维度'
    },
    submitType: {
      type: String,
      default: 'add'
    },
    value: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      textValue: '',
      confirmLoading: false,
    }
  },
  computed: {
    maxlength() {
      return this.submitType === 'edit' ? 30 : 1000;
    },
    placeholder() {
      return this.submitType === 'edit' ?
        '回显维度名称，以及对应名称字数' :
        '请点此添加维度（每行一个）\n组织能力\n创新能力\n......';
    },
  },
  watch: {
    visibility: {
      handler(bool) {
        if (bool) {
          this.textValue = this.value;
        } else {
          this.textValue = '';
        }
      },
      immediate: true
    }
  },
  methods: {
    cancelHandle() {
      this.visibility = false;
      this.textValue = '';
    },
    emitConfirm() {
      const source = {
        value: this.textValue,
        submitType: this.submitType
      };
      if (typeof this.onConfirm === 'function') {
        this.onConfirm(source);
      } else {
        this.$emit('confirm', source);
      }
    },
    confirmHandle() {
      if (this.textValue.trim().length === 0) {
        this.$message.warning('请填写维度信息');
      } else {
        if (this.submitType === 'edit') {
          // 编辑
          this.confirmLoading = true;
          const req = {
            [this.value]: this.textValue.trim()
          };
          editDimension(req).then((res) => {
            const { code, msg } = res.data || {};
            if (code === 0) {
              this.$message.success('修改维度成功');
              this.cancelHandle();
              this.emitConfirm();
            } else {
              this.$message.error(msg ?? '修改维度失败');
            }
          }).catch(() => {
            this.$message.error('修改维度失败');
          }).finally(() => {
            this.confirmLoading = false;
          });
        } else {
          // 新增
          const arrValue = this.textValue.split('\n').map((val) => val.trim())
          const dimensionNames = arrValue.map((val) => {
            return val.substr(0, 30);
          });
          this.confirmLoading = true;
          addDimension(dimensionNames).then((res) => {
            const { code, msg } = res.data || {};
            if (code === 0) {
              this.$message.success('添加维度成功');
              this.cancelHandle();
              this.emitConfirm();
            } else {
              this.$message.error(msg ?? '添加维度失败');
            }
          }).catch(() => {
            this.$message.error('添加维度失败');
          }).finally(() => {
            this.confirmLoading = false;
          });
        }
      }
    }
  }
}
</script>